import Logo from 'components/atoms/Logo';
import Title from 'components/atoms/Title';
import LoginForm from 'components/organisms/LoginForm';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useContext, useLayoutEffect } from 'react';
import { Navigate } from 'react-router';
import useLoginPage from './hooks/useLoginPage';

import './styles.scss';

const LoginPage = () => {
  const { setIsVisibleHeader, user } = useContext(GlobalContext);
  const { error, onSubmit } = useLoginPage();

  useLayoutEffect(() => {
    setIsVisibleHeader(false);
    return () => setIsVisibleHeader(true);
  }, [setIsVisibleHeader]);

  if (user.isAuthenticated) return <Navigate to="/" replace />;

  return (
    <>
      <div className="loginPage">
        <header className="loginPage__header">
          <Logo />
          <Title>Normas Técnicas & Desenhos Padrão</Title>
        </header>
        <LoginForm onSubmit={onSubmit} error={error} />
      </div>
    </>
  );
};

export default LoginPage;
